<template functional>
  <div
    class="my-5"
    v-bind="data.attrs"
    :class="[data.class, data.staticClass, `container-${props.width}`]"
  >
    <header v-if="slots().header" class="text-center mb-5">
      <slot name="header"></slot>
    </header>

    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "lg",
      validator(val) {
        return ["full", "lg", "md", "sm"].includes(val)
      }
    }
  }
}
</script>
